// Menu
import MenuOverlayToggler from "./components/menu/MenuOverlayToggler.js";

// Core blocks
import CoverVideo from "./components/core-blocks/CoverVideo.js";
import MediaTextVideo from "./components/core-blocks/MediaTextVideo.js";
import Video from "./components/core-blocks/Video.js";
import VimeoEmbed from "./components/core-blocks/VimeoEmbed.js";
import YouTubeEmbed from "./components/core-blocks/YouTubeEmbed.js";

// ACF blocks
import PostList from "./components/acf-blocks/PostList.js";
import Summary from "./components/acf-blocks/Summary.js";
import Quiz from "./components/acf-blocks/Quiz.js";

// Accessibility
import SkipLink from "./components/accessibility/SkipLink.js";
import ReplaceMarkWithSpan from "./components/accessibility/ReplaceMarkWithSpan.js";

// Forms
import WPForms from "./components/forms/WPForms.js";

// Cookie Compliance
import CookieCompliance from "./components/cookie-compliance/CookieCompliance.js";

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh/10}rem`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight/10}rem`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Blocks
document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(block => new CoverVideo(block));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach(block => new MediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new VimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new YouTubeEmbed(block));
document.querySelectorAll('.wp-block-video-wrapper').forEach(domEl => new Video(domEl));

document.querySelectorAll('.acf-block-post-list').forEach(domEl => new PostList(domEl));
document.querySelectorAll('.acf-block-summary').forEach(domEl => new Summary(domEl));
document.querySelectorAll('.acf-block-quiz').forEach(domEl => new Quiz(domEl));

//
// Menus
new MenuOverlayToggler();
if(document.body.classList.contains('single-post')) {
	const menuItemPosts = document.querySelector('#menu-1 .menu_page-posts');
	if(menuItemPosts) {
		menuItemPosts.classList.add('js-active');
	}
}

//
// Accessibility + Search stuff
new SkipLink();
new ReplaceMarkWithSpan();

//
// Forms
new WPForms();

// Use this in test development
/*
document.addEventListener('focus', function(event) {
	console.log(event.target);
}, true); // Use true for capturing phase, to ensure we capture all focus events.
*/

//
// Cookie Compliance
new CookieCompliance();